module.exports = __webpack_public_path__ + "img/samford-university.13257a41.png";